import { render } from "./EditElement.vue?vue&type=template&id=43dadf08&scoped=true"
import script from "./EditElement.vue?vue&type=script&lang=js"
export * from "./EditElement.vue?vue&type=script&lang=js"

import "./EditElement.vue?vue&type=style&index=0&id=43dadf08&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43dadf08"]])

export default __exports__